export default __webpack_public_path__ + "static/media/Ghat.5f7b1421.jpg";